import { render } from "./inviteForm.vue?vue&type=template&id=13a516a3"
import script from "./inviteForm.vue?vue&type=script&lang=js"
export * from "./inviteForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__